import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8a34c0a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ReturnSlip_operationWrapper" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "ReturnSlip_BtnBlock" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_7 = { class: "ReturnSlip_Table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "詳細", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "ta_r" }
const _hoisted_19 = {
  key: 0,
  class: "ResultMessageNull"
}

import OrderHeader from "../components/OrderHeader.vue";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import { onMounted, ref } from "vue";
import { useStore } from "vuex";
import Paginate from "vuejs-paginate-next";
import { useRouter } from "vue-router";
import axios from "axios";
import { Notyf } from "notyf";
import CsvHelper from "../functions/CsvHelper.js";

interface DeliverySlip {
  bansen: string;
  beforeSyuuseiNouhinDate: string;
  beforeSyuuseiNouhinNumber: number;
  denpyouNumber: string;
  eventMei: string;
  eventNumber: number;
  hanmotoCd: string;
  hannyuDate: string;
  hannyusakiCd: string;
  hannyusakiMei: string;
  isbn: string;
  joukenKbn: number;
  joukenMei: string;
  juchuuSuu: number;
  kaisuu: number;
  kikan: number;
  meisaiNumber: number;
  nouhinRemarks: string;
  remarks: string;
  seikyuuDate: string;
  syosiCd: string;
  syotenMei: string;
  syouhinSyubetu: number;
  syouhinSyubetuMei: string;
  syoumiKakeritu: number;
  syoumiPrice: number;
  syoumiRitu: number;
  syukkoSuu: number;
  syuppanSyosiCd: string;
  teiseiDate: null;
  teiseiReason: string;
  title: string;
  toritugiCd: string;
  toritugiKyoukaiCd: string;
  toritugiMei: string;
  toritugiSyotenMei: string;
  totalSyoumiPrice: number;
  tourokuDate: string;
  tourokuTime: string;
  zaikoEventKbn: number;
  zaikoEventMei: string;
  zassiCd: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeliverySlip',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const store = useStore();
const props = __props;
const router = useRouter();
const { getTimeStamp } = CsvHelper();



//ぱんくずヘッダー
const currentPathList = [{ name: "伝票照会" }, { name: "納品伝票" }];
// ストアの初期化------------------------------------------------
store.commit("search/clearAuthData");

// 全体で使用する変数--------------------------------------------
// ソート関連
let sortInfo = ref({
  sortItem: "",
  isKoujun: false,
});
let isSorting = ref(false);

// テーブル表示項目----------------------------------------------
// 型定義
let searchAreaToggle: boolean = true;
let search_result = ref<DeliverySlip[]>([]);

//検索ヘッダ関連----------------------------------------------
let isActiveKaniFlg = ref<boolean>(false);
let isActive_SyosaiFlg = ref<boolean>(true);
let isOpentoggleArea = ref<boolean>(true);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActiveKaniFlg.value = KaniFlg;
};
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};

// データ取得関連---------------------------------------------
//検索処理
const onSearch = (): void => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  isSorting.value = false;
  getDeliverySlipData();
};

const getDeliverySlipData = async (): Promise<void> => {
  search_result.value.splice(0);
  if (isSorting.value === true) {
    await store.dispatch("search/sortDeliverySlip", {
      sortItem: sortInfo.value.sortItem,
      isKoujun: sortInfo.value.isKoujun,
    });
  } else {
    await store.dispatch("search/searchDeliverySlip");
  }
  const res = store.getters["search/getDeliverySlipData"];
  res.mstNouhinDenpyou.forEach((nouhin: DeliverySlip) => {
    search_result.value.push(nouhin);
  });
  numberOfTotalData.value = res.size;
  firstCount.value = res.firstCount;
  finalCount.value = res.finalCount;
  getTotalPage();
};
onMounted(() => {
  getDeliverySlipData();
});

// ページネーション関連処理------------------------------------
// 取得データ合計
let numberOfTotalData = ref(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
// 総ページ数
const numberOfTotalPage = ref(0);
//表示中のページ範囲
let firstCount = ref(0);
let finalCount = ref(0);

// 現在のページ数
const currentPage = ref(1);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};

const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  getDeliverySlipData();
};

// テーブルソート処理--------------------------------------------------------------------------------------
const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;

  getDeliverySlipData();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};

// 詳細画面関連-----------------------------------------------
const openTab = async (denpyouNumber: string) => {
  console.log(denpyouNumber);

  let resolvedRoute = router.resolve({
    name: "DeliverySlipDetail",
    params: { id: denpyouNumber },
  });
  window.open(
    resolvedRoute.href,
    "_blank",
    "width=1200,height=600,scrollbars=1,location=0,menubar=0,toolbar=0,status=1,directories=0,resizable=1,left=" +
      (window.screen.width - 1000) / 2 +
      ",top=" +
      (window.screen.height - 650) / 2
  );
};

// ダウンロード関連--------------------------------------------
let isDownLoading = ref(false);
const getCsvData = async () => {
  isDownLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getDeliverySlipState"];
  try {
    isDownLoading.value = true;
    const searchParams = `fromHannyuDate=${
      detailState.fromHannyuDate
    }&toHannyuDate=${detailState.toHannyuDate}&eventMei=${
      detailState.eventMei
    }&toritugiCd=${detailState.toritugiCd}&joukenKbn=${
      detailState.joukenKbn
    }&fromSeikyuuDate=${detailState.fromSeikyuuDate}&toSeikyuuDate=${
      detailState.toSeikyuuDate
    }&fromTourokuDate=${detailState.fromTourokuDate}&toTourokuDate=${
      detailState.toTourokuDate
    }&syubetu=${detailState.syubetu}&freeword=${simpleState}&hanmotoCd=${
      store.getters["login/getUserData"].hanmotoCd
    }&denpyouNumber=${detailState.denpyouNumber}&syosiCd=${
      detailState.syosiCd
    }&page=${store.getters["search/getPageNumber"]}&numberOfDisplay=&order=${
      isSorting.value ? sortInfo.value.sortItem : ""
    }&sort=${isSorting.value ? sortInfo.value.isKoujun : ""}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/denpyou/nouhin/download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      }
    );
    isDownLoading.value = false;
    if (res.data === "") {
      notyf.error("ダウンロードするデータがありません");
    } else {
      let blob = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let link = document.createElement("a");
      link.href = window.URL.createObjectURL(blob);
      link.download = `納品伝票_${getTimeStamp()}.xlsx`;
      link.click();
      isDownLoading.value = false;
    }
  } catch (error) {
    isDownLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};

// レイアウト関連----------------------------------------------
//テーブルの高さ判定
const tableHeight = () => {
  if (isActive_SyosaiFlg.value && isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "ReturnSlip_TableContainer_Short";
  } else {
    //その他
    return "ReturnSlip_TableContainer_Long";
  }
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ReturnSlip", {
      Show_KaniSearch: _unref(isActiveKaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActiveKaniFlg: _unref(isActiveKaniFlg),
      isActive_SyosaiFlg: _unref(isActive_SyosaiFlg),
      isActive_SidebarFlg: __props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      searchType: "deliverySlip",
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onChangeToggleArea: changeToggleArea,
      onOnSearch: onSearch
    }, null, 8, ["isActiveKaniFlg", "isActive_SyosaiFlg", "isActive_SidebarFlg", "searchAreaToggle"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, _unref(search_result).length]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["ReturnSlip_BtnGray", { ReturnSlip_BtnDisabled: _unref(isDownLoading) }]),
          download: "sample.txt",
          onClick: getCsvData,
          disabled: _unref(isDownLoading)
        }, [
          (!_unref(isDownLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isDownLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 10, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["ReturnSlip_TableContainer", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("th", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable('hanmotoCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 版元"),
              _hoisted_9,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hanmotoCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('hannyuDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 搬入日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hannyuDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('denpyouNumber'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 伝票NO"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("denpyouNumber")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('zaikoEventMei'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 在庫"),
              _hoisted_10,
              _createTextVNode("イベント名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("zaikoEventMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('eventMei'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" イベント名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("eventMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('toritugiKyoukaiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次協会"),
              _hoisted_11,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiKyoukaiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (sortTable('toritugiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 取次"),
              _hoisted_12,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('toritugiMei'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 取次名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('hannyusakiCd'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 搬入先"),
              _hoisted_13,
              _createTextVNode("コード"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hannyusakiCd")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('hannyusakiMei'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 搬入先名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("hannyusakiMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('toritugiSyotenMei'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 取次書店名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("toritugiSyotenMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('bansen'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 番線"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("bansen")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[12] || (_cache[12] = ($event: any) => (sortTable('syotenMei'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 書店名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("syotenMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (sortTable('joukenMei'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 条件名"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("joukenMei")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[14] || (_cache[14] = ($event: any) => (sortTable('kikan'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 期間"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("kikan")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[15] || (_cache[15] = ($event: any) => (sortTable('kaisuu'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 回数"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("kaisuu")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[16] || (_cache[16] = ($event: any) => (sortTable('seikyuuDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 請求日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("seikyuuDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[17] || (_cache[17] = ($event: any) => (sortTable('syoumiRitu'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 正味率"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("syoumiRitu")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[18] || (_cache[18] = ($event: any) => (sortTable('syoumiPrice'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 正味金額"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("syoumiPrice")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[19] || (_cache[19] = ($event: any) => (sortTable('beforeSyuuseiNouhinDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 修正前"),
              _hoisted_14,
              _createTextVNode("納品日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("beforeSyuuseiNouhinDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[20] || (_cache[20] = ($event: any) => (sortTable('beforeSyuuseiNouhinNumber'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 修正前"),
              _hoisted_15,
              _createTextVNode("納品NO"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("beforeSyuuseiNouhinNumber")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[21] || (_cache[21] = ($event: any) => (sortTable('teiseiReason'))),
              class: "TH_Normal th_sort"
            }, [
              _createTextVNode(" 訂正理由"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("teiseiReason")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[22] || (_cache[22] = ($event: any) => (sortTable('teiseiDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 訂正日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("teiseiDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[23] || (_cache[23] = ($event: any) => (sortTable('tourokuDate'))),
              class: "TH_Medium th_sort"
            }, [
              _createTextVNode(" 登録日"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("tourokuDate")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[24] || (_cache[24] = ($event: any) => (sortTable('tourokuTime'))),
              class: "th_sort"
            }, [
              _createTextVNode(" 登録時間"),
              _createElementVNode("span", null, _toDisplayString(showSortSymbol("tourokuTime")), 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[25] || (_cache[25] = ($event: any) => (sortTable('eventMei')))
            }, "備考"),
            _createElementVNode("th", {
              onClick: _cache[26] || (_cache[26] = ($event: any) => (sortTable('eventMei')))
            }, "納品備考")
          ])
        ]),
        (_unref(search_result).length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(search_result), (result, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (openTab(result.denpyouNumber)),
                      class: "ReturnSlip_Table_Button"
                    }, " 詳細 ", 8, _hoisted_17)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(result.hanmotoCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hannyuDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.denpyouNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(result.zaikoEventMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.eventMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiKyoukaiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hannyusakiCd), 1),
                  _createElementVNode("td", null, _toDisplayString(result.hannyusakiMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.toritugiSyotenMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.bansen), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syotenMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.joukenMei), 1),
                  _createElementVNode("td", null, _toDisplayString(result.kikan), 1),
                  _createElementVNode("td", null, _toDisplayString(result.kaisuu), 1),
                  _createElementVNode("td", null, _toDisplayString(result.seikyuuDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.syoumiRitu), 1),
                  _createElementVNode("td", _hoisted_18, _toDisplayString(result.totalSyoumiPrice !== null
                  ? result.totalSyoumiPrice.toLocaleString()
                  : result.totalSyoumiPrice), 1),
                  _createElementVNode("td", null, _toDisplayString(result.beforeSyuuseiNouhinDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.beforeSyuuseiNouhinNumber), 1),
                  _createElementVNode("td", null, _toDisplayString(result.teiseiReason), 1),
                  _createElementVNode("td", null, _toDisplayString(result.teiseiDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.tourokuDate), 1),
                  _createElementVNode("td", null, _toDisplayString(result.tourokuTime), 1),
                  _createElementVNode("td", null, _toDisplayString(result.remarks), 1),
                  _createElementVNode("td", null, _toDisplayString(result.nouhinRemarks), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_unref(search_result).length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})